import React from 'react';
import Enemies from 'src/components/Enemies';
import Details from 'src/components/Details';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import useSparkSyncSuspendEnable, {
  UseSparkSyncSuspendEnableReturn,
} from 'src/SharedCustomHooks/UseSparkSync/useSparkSyncSuspendEnable';
import SparkSyncSuspendButton from 'src/components/HeadingWithDetails/Components/SparkSyncButton';
import './service-request-heading.scss';

interface ServiceRequestHeadingProps {
  headline?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  actions?: React.ReactNode;
  toast?: React.ReactNode;
  items?: React.ReactNode[];
  status?: string;
  style?: React.CSSProperties;
  filedIn?: any;
  propertyId?: string;
  compact?: boolean;
  aside?: React.ReactNode;
}

const ServiceRequestHeading = ({
  actions,
  breadcrumb,
  status,
  headline,
  items,
  style,
  toast,
  filedIn,
  propertyId,
  compact = false,
  aside,
}: ServiceRequestHeadingProps) => {
  const {
    isSpark,
    sparkSyncSuspended,
    isTogglingSuspend,
    isConfirmModalOpen,
    openSuspendConfirmModal,
    closeConfirmModal,
    confirmSuspendAction,
    confirmModalProps,
  }: UseSparkSyncSuspendEnableReturn = useSparkSyncSuspendEnable(propertyId);

  const showSparkSyncButtons: boolean = propertyId && isSpark;

  return (
    <div className="sr-heading">
      {style && <div className="sr-heading-image" style={style} />}
      <div
        className={`sr-heading-wrapper${compact ? ' sr-heading-wrapper-compact' : ''}`}
      >
        {breadcrumb && (
          <div className="sr-heading-breadcrumb">{breadcrumb}</div>
        )}
        <div
          className={
            status === 'On Hold' ? 'sr-heading-body-yellow' : 'sr-heading-body'
          }
        >
          {toast && <div className="sr-heading-top">{toast}</div>}
          <div className="sr-heading-bottom">
            {aside ? (
              <div className="sr-heading-bottom-row">
                <div className="sr-heading-left-content">
                  <div className="sr-heading-bottom-main">
                    <Enemies>
                      {headline && (
                        <div className="sr-heading-headline">{headline}</div>
                      )}
                    </Enemies>
                    {filedIn && <div>Filed in: {filedIn}</div>}
                  </div>
                  <div className="sr-heading-bottom-aside">{aside}</div>
                </div>

                {actions && (
                  <div className="sr-heading-actions">
                    {showSparkSyncButtons && (
                      <SparkSyncSuspendButton
                        sparkSyncSuspended={sparkSyncSuspended}
                        isTogglingSuspend={isTogglingSuspend}
                        onToggleSuspend={openSuspendConfirmModal}
                      />
                    )}
                    <div className="sr-heading-action-buttons">{actions}</div>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Enemies>
                  {headline && (
                    <div className="sr-heading-headline">{headline}</div>
                  )}
                </Enemies>
                {filedIn && <div>Filed in: {filedIn}</div>}
              </>
            )}

            <div className="sr-heading-details">
              <Details items={items?.filter((item: any) => item)} />
            </div>
          </div>
        </div>
      </div>
      {isConfirmModalOpen && (
        <ConfirmationModal
          title={confirmModalProps.title}
          message={confirmModalProps.message}
          confirmLabel={confirmModalProps.confirmLabel}
          cancelLabel={confirmModalProps.cancelLabel}
          variant={confirmModalProps.variant}
          requireTypeToConfirm={confirmModalProps.requireTypeToConfirm}
          confirmationWord={confirmModalProps.confirmationWord}
          onConfirm={confirmSuspendAction}
          onCancel={closeConfirmModal}
          isSubmitting={isTogglingSuspend}
        />
      )}
    </div>
  );
};

export default ServiceRequestHeading;
